import * as React from 'react';
import { List, Datagrid, TextField } from 'react-admin';
import Filter from './filter';
import Pagination from '../pagination';
import { PROVIDER_STATUSES } from '../../constants';

const StatusField = ({ record, source }) => {
  const status = PROVIDER_STATUSES.find((status) => status.id === record[source]);
  if (status) return <span>{status.name}</span>;
  return null;
};

export default (props) => (
  <List
    filters={<Filter permissions={props.permissions} />}
    sort={{ field: 'id', order: 'DESC' }}
    pagination={<Pagination />}
    perPage={100}
    bulkActionButtons={false}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="brand" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <TextField source="country" />
      <StatusField source="status" />
    </Datagrid>
  </List>
);
